import './text-block.scss';

export default () => {
	$( '.js-back-top' ).on( 'click', function ( e ) {
		e.preventDefault();
		$( 'html,body' ).animate( {
			scrollTop: 0,
		}, 500 );
	} );
};
